import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

const PaymentMethodImageWrapper = styled.img`
  flex-wrap: wrap;
  margin-bottom: 26px;
  margin-right: 4px;

  &:last-child {
    margin-right: 0px;
  }
`

const PaymentMethodImage = ( { alt, src } ) => {
  return (
    <PaymentMethodImageWrapper
      alt={ alt }
      loading="lazy"
      src={ src }
    />
  )
}

PaymentMethodImage.propTypes = {
  'alt': PropTypes.string.isRequired,
  'src': PropTypes.string.isRequired
}

export default PaymentMethodImage
